/**
 * 接口域名的管理
 */
const base = {
    businessBase:"/kapi/app/mal/malwebapi"
};

export default base;